
document.addEventListener("DOMContentLoaded", function () {
    const pinField = document.getElementById("checkPin"),
    pinError = document.querySelector(".checkout_error"),
    pinStatus = document.querySelector(".checkStatus"),
    pin_regex = /^[1-9][0-9]{5}$/;

    pinField.addEventListener("keyup", function () {
        this.value = this.value.replace(/\D/g, "");
        pincodeValidation();
    });

    function pincodeValidation() {
        const pincode = pinField.value.trim();

        if (pincode.length < 6 || !pin_regex.test(pincode)) {
        displayError("Please enter a valid Pincode");
        return;
        }

        const apiUrl = `https://shopify.wforwoman.com/pincodes/shiprocket/service/${pincode}`;
        $.ajax({
        url: apiUrl,
        method: "GET",
        dataType: "json",
        success: function (response) {
            if (
            response.success &&
            response.data &&
            response.data.data &&
            Array.isArray(response.data.data.available_courier_companies) &&
            response.data.data.available_courier_companies.length > 0
            ) {
            const firstCourier =
                response.data.data.available_courier_companies[0];
            const estDays = parseInt(
                firstCourier.estimated_delivery_days || 1,
                10,
            );
            localStorage.setItem("ExistPincode", pincode);
            localStorage.setItem("TAT", estDays);
            displayDeliveryDate(estDays);
            } else {
            displayError("Delivery pincode not serviceable.");
            }
        },
        error: function () {
            // $('#responsemessage').text('Error fetching data. Please ensure the API is working.');
        },
        });
    }

    function displayError(message) {
        pinError.innerHTML = `<span class="errorMsg">${message}</span>`;
        pinStatus.innerHTML = "";
        pinStatus.classList.remove("success");
    }

    function displayDeliveryDate(delivery_day) {
        const next_dt = new Date();
        next_dt.setDate(next_dt.getDate() + delivery_day);

        const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
        ];
        const dayNames = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        ];

        const deliveryMessage = `${dayNames[next_dt.getDay()]}, ${monthNames[next_dt.getMonth()]} ${next_dt.getDate()}`;
        pinStatus.innerHTML = `<span class="greenPincode1"><u>FREE delivery:</u></span><b style="font-size:14px;letter-spacing: 0px; font-family: Avenir-Roman;"> ${deliveryMessage}</b><span class="greenPincode"><span class="freegreen">Free delivery</span></span>`;
        pinStatus.classList.add("success");
        pinError.innerHTML = "";
    }

    const existingPin = localStorage.getItem("ExistPincode");
    const existingDays = parseInt(localStorage.getItem("DeliveryDays"));

    if (existingPin) pinField.value = existingPin;
    if (!isNaN(existingDays)) displayDeliveryDate(existingDays);
});
